module.exports = __webpack_public_path__ + "static/media/hand_lettered_concept_for_herbal_medicine_company_3_2019.562907f1.webp";